module.exports = __webpack_public_path__ + "static/404_image-6d2fab1f3b824c0c0552741b6b5d051f.jpg";